export { createAlertMessageBlock };

function createAlertMessageBlock(data) {
  const messageTitle = data.col[0];
  const messageContent = data.col.length > 1 ? data.col[1] : '';

  if (messageContent.length > 0 && (messageContent.startsWith('/') || messageContent.startsWith('http'))) {
    const $block = document.createElement('div');
    $block.classList.add('notice');
    {
      const $a = document.createElement('a');
      $a.target = '_blank';
      $a.href = messageContent;
      $a.textContent = messageTitle;
      $block.appendChild($a);
    }
    return $block;
  }

  const $block = document.createElement('div');
  $block.classList.add('notice', 'accordion-item', 'js-accordion-trigger');
  {
    const $div = document.createElement('div');
    $div.classList.add('accordion-title', 'wrapper', 'container-fluid');
    $div.textContent = messageTitle;
    $block.appendChild($div);
  }
  {
    const $div = document.createElement('div');
    $div.classList.add('accordion-content', 'wrapper', 'container-fluid');
    $div.textContent = messageContent;
    $block.appendChild($div);
  }
  return $block;
}
